import React from "react";
import { IntlProvider } from "react-intl";
import Header from "./Header/header";
import Footer from "./Footer/footer";
import { translations, handleCookieLocale } from "@translations/i18n";
import "./layout.scss";

const Layout = ({ locale, children }) => {
  handleCookieLocale(locale);

  return (
    <IntlProvider locale={locale} messages={translations[locale]}>
      <div id="top-of-page">
        <Header locale={locale} />
        <div>
          <main>{children}</main> 
        </div>
        <Footer locale={locale} />
      </div>
    </IntlProvider>
  );
};

export default Layout;
